/**
 * useDepos — Depo list hook with cross-tab synced cache.
 *
 * Şub 03, 2026: module-level cache eklendi.
 * Haz 13, 2026: cross-tab senkron (BroadcastChannel + focus refetch).
 * Haz 13, 2026: generic `createSharedCache` factory'sine refactor edildi
 * (kod tekrarı yok; aynı pattern useFirms vb. için yeniden kullanılıyor).
 *
 * Public API (geriye uyumlu):
 *   const { depos, loading, refresh } = useDepos();
 *   invalidateDepos();
 */
import api from './api';
import { createSharedCache } from './createSharedCache';

const { useShared, invalidate } = createSharedCache({
  channel: 'depos-cache',
  fetcher: () => api.get('/depos').then((r) => r.data?.data || []),
});

export function useDepos() {
  const { data, loading, refresh } = useShared();
  return { depos: data, loading, refresh };
}

export const invalidateDepos = invalidate;
